import { CustomTheme as Theme } from './@types';

export const theme: Theme = {
	globals: {
		body: {
			font: {
				family:
					"'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif"
			},
			colors: {
				background: '#1e272e'
			}
		},
		code: {
			font: {
				family: "source-code-pro, Menlo, Monaco, Consolas, 'Courier New',  monospace"
			}
		}
	},

	error: {
		colors: {
			foreground: '#ff3f34'
		}
	},
	header: {
		colors: {
			background: '#05c46b',
			foreground: '#1e272e'
		}
	}
};

export type CustomTheme = Theme;
